import { PageGen, PdfRect } from '../pdf/pdf';

export const IGenPartSymbol = Symbol('GenPart');

export interface IGenPart {
  draw(page: PageGen, rect: PdfRect, data: string): void;
}
